
let _getPhrase;
let _getColumnText;
let _getFormItemLabel;
let _getIconHint;

export function getPhrase(phraseId) {
	return _getPhrase(phraseId) || phraseId;
}

export function formatPhrase(phrase, params) {
	return phrase;
}

export function getColumnText(columnName, entityName, preferShort, context) {
	return _getColumnText(columnName, entityName, preferShort, context);
}

export function getFormItemLabel(itemName, entityName) {
	return _getFormItemLabel(itemName, entityName);
}

export function getFormItemLabelFor(entityName) {
	return function(itemName) {
		return getFormItemLabel(itemName, entityName);
	};
}

export function getIconHint(iconId, entityName) {
	return _getIconHint(iconId, entityName);
}


export function initializePhrases(obj) {
	window.obj = obj;

	_getPhrase = obj.getPhrase || ((phraseId) => phraseId);
	_getColumnText = obj.getColumnText || ((columnName) => columnName);
	_getFormItemLabel = obj.getFormItemLabel || ((itemName) => itemName);
	_getIconHint = obj.getIconHint || (() => null);



}


initializePhrases({});

